<template>
  <div>
    <div class="mb-2">
      <va-input v-model="form.code" class="mb-0" placeholder="Промокод" />
      <div
        v-if="!$v.form.code.required && $v.form.code.$error"
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-2">
      <va-input
        v-model="form.discount"
        class="mb-0"
        type="number"
        placeholder="Cкидка"
        @keypress="isNumber($event)"
      />
      <div
        v-if="!$v.form.discount.required && $v.form.discount.$error"
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-2">
      <va-input
        disabled
        class="mb-0"
        :value="String(form.expires_at)"
        placeholder="Срок действия промокода"
      />
      <div
        v-if="!$v.form.expires_at.required && $v.form.expires_at.$error"
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mt-2">
      <date-picker
        v-model="form.expires_at"
        is-required
        mode="date"
        :model-config="modelConfig"
        :min-date="new Date()"
      />
    </div>
    <div class="mt-4 text-center">
      <va-button @click="$emit('close')">Отменить</va-button>
      <va-button color="info" @click="submitHandler">Сохранить</va-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api/axios";
import { DatePicker } from "v-calendar";
import { required } from "vuelidate/lib/validators";
Vue.component("date-picker", DatePicker);
export default {
  name: "PromocodeCreate",
  data() {
    return {
      form: {
        code: "",
        discount: "",
        expires_at: "",
      },
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
    };
  },
  validations: {
    form: {
      code: {
        required,
      },
      discount: {
        required,
      },
      expires_at: {
        required,
      },
    },
  },
  methods: {
    async submitHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        const { code, expires_at, discount } = this.form;
        const requiredData = {
          code,
          discount: Number(discount),
          expires_at: expires_at,
        };
        try {
          await api.post("/admin/promocodes", requiredData);
          this.$emit("needFetchPromocodes");
          this.$emit("close");
        } catch (error) {
          const samePromocodeError = error.response.data.errors.code;
          const discountError = error.response.data.errors.discount;
          if (samePromocodeError) {
            alert("Промокод уже используется");
          }
          if (discountError) {
            alert("Скидка не может быть больше 100");
          } else {
            return error;
          }
        }
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
